import { render, staticRenderFns } from "./AppWysiwygEditor.vue?vue&type=template&id=25eb44e0&scoped=true&"
import script from "./AppWysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./AppWysiwygEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb44e0",
  null
  
)

export default component.exports